var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete"},[_c('div',{staticClass:"icon",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"size":"13","color":"#FF0054"}},[_vm._v("fa-regular fa-trash")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }